<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>favorite</md-icon>
          </div>
          <h4 class="title">Add Long Take on Assignment (Activity Labourer Workplace)</h4>
        </md-card-header>

        <form @submit.prevent="add">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Back to List
              </md-button>
            </div>
            <select-input-horizontal
                v-model="activityLabourerWorkplace.activity_id"
                :options="activities"
                placeholder="Select Activity"
                label="Activity"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.activity_id"
            ></select-input-horizontal>

            <select-input-horizontal
                v-model="activityLabourerWorkplace.labourer_id"
                :options="labourers"
                placeholder="Select Labourer"
                label="Labourer"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                @search="labourerFind"
                :error="apiValidationErrors.labourer_id"
            ></select-input-horizontal>

            <select-input-horizontal
                v-model="activityLabourerWorkplace.workplace_id"
                :options="workplaces"
                placeholder="Select Workplace"
                label="Workplace"
                name="name"
                track-by="id"
                main-class="md-layout"
                :allow-empty="false"
                deselect-label="Can't remove"
                label-class="md-layout-item md-size-25 md-form-label"
                :error="apiValidationErrors.workplace_id"
            ></select-input-horizontal>
            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Start Date
              </label>
              <div class="md-layout-item">
                <md-datepicker v-model="startDate">
                  <label>Select date</label>
                </md-datepicker>
                <validation-error :errors="apiValidationErrors.start_date"/>
              </div>
            </div>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success">Submit Assignment</md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import SelectInputHorizontal from '@/components/Inputs/SelectInputHorizontal.vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export default {
    components: { SelectInputHorizontal, ValidationError },

    mixins: [formMixin],

    data () {
        return {
            activityLabourerWorkplace: {
                type: 'activityLabourerWorkplaces',
                labourer_id: null,
                workplace_id: null,
                activity_id: null,
                start_date: null
            },
            activities: [],
            workplaces: [],
            labourers: [],
        };
    },
    created () {
        this.getLabourers();
        this.getActivities();
        this.getWorkplaces();
    },
    computed: {
        startDate: {
            get () {
                if (!this.activityLabourerWorkplace.start_date) {
                    return null;
                }
                return dayjs
                    .utc(this.activityLabourerWorkplace.start_date)
                    .tz('Africa/Dar_es_Salaam')
                    .format('YYYY-MM-DD');
            },
            set (value) {
                this.activityLabourerWorkplace.start_date = value;
            }
        }
    },
    methods: {
        async add () {
            try {
                // this.activityLabourerWorkplace.start_date = ;
                await this.$store.dispatch('activityLabourerWorkplaces/add', this.activityLabourerWorkplace);
                this.notifySuccess('Labourer Assigned to Workplace and Activity.');
                this.goBack();
            } catch (e) {
                console.log(e);
                if (e.response && e.response.data && e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getLabourers () {
            this.$store.dispatch('labourers/list').then(() => {
                this.labourers = this.$store.getters['labourers/list'];
            });
        },
        getWorkplaces () {
            this.$store.dispatch('workplaces/list').then(() => {
                this.workplaces = this.$store.getters['workplaces/list'];
            });
        },
        getActivities () {
            this.$store.dispatch('activities/list').then(() => {
                this.activities = this.$store.getters['activities/list'];
            });
        },
        goBack () {
            this.$router.push({ name: 'List Activity Labourer Workplace' });
        },
        async labourerFind (query, id) {
            this.isLoading = true;
            let params = {
                filter: { queryKey: query }
            };
            await this.$store.dispatch('labourers/list', params).then(() => {
                this.labourers = this.$store.getters['labourers/list'];
                this.isLoading = false;
            });
        },
    },
};
</script>
